module.exports = __webpack_public_path__ + "img/study.62893a44.png";